// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AdminSideMenu_wrap_sby9V","icon":"AdminSideMenu_icon_3rg5u"};